import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ptBR from './i18n/pt-br.json'

Vue.use(VueI18n)

const DEFAULT_LANG = 'pt-br'
// const DEFAULT_LANG = 'en'

const messages = {
    en: Object.assign(import('./i18n/en.json')),
    'pt-br': { ...ptBR },
}

const i18n = new VueI18n({
    locale: DEFAULT_LANG,
    messages,
})

export default i18n
